import { UserSyncSettings } from '@/types_cp/user/settings';

export const DEFAULT_SYNC_CONFIG: UserSyncSettings = {
  webrtc: { enabled: false },
};
